import Component from '../core/Component'

export const STATES = {
    ACTIVE: 'is-active'
}

export default class ShareOnCopy extends Component {
    constructor(element) {
        super(element)

        this.ref = {
            alert: null
        }
    }

    prepare() {
        this.element.addEventListener('click', this.handleClick)
    }

    handleClick = () => {
        this.render()
    }

    render() {
        this.showMessage()
    }

    showMessage() {
        if(this.ref.alert.classList.contains('is-active')) {
            this.ref.alert.classList.remove(STATES.ACTIVE)
        }

        navigator.clipboard.writeText(window.location.href)

        this.sleep(1).then(() => {this.ref.alert.classList.add(STATES.ACTIVE)})
    }

    sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms))
    }
}
